import React from "react";
import Golfers from "./Golfers";
import Entries from "./Entries";
import Standings from "./Standings";
import Header from "./Header";
import Footer from "./Footer";
import { IsFinalProvider } from "../context/IsFinalContext";

function MainContent() {
    return (
        <div>
            <Header />
            <div className="flex flex-col lg:flex-row justify-around flex-wrap">
                <Standings />
                <Golfers />
            </div>
            <Entries />
            <Footer />
        </div>
    );
}

export default function Main() {
    return (
        <IsFinalProvider>
            <MainContent />
        </IsFinalProvider>
    );
}